const table = [
    {
        prop: 'Region',
        label: 'Región',
        minWidth: 100
    },
    {
        prop: 'Depart_Code',
        label: 'Cod. Dpto.',
        minWidth: 100
    },    
    {
        prop: 'NameDpto',
        label: 'Departamento',
        minWidth: 150
    },
    {
        prop: 'MunCode',
        label: 'Cod. Munic.',
        minWidth: 100
    },    
    {
        prop: 'NMunicipio',
        label: 'Municipio',
        minWidth: 150
    },
    {
        prop: 'IDPunto',
        label: 'ID Punto',
        minWidth: 150
    },
    {
        prop: 'Cedula',
        label: 'Cédula',
        minWidth: 150
    },
    {
        prop: 'NroTiket',
        label: 'Nro. Ticket',
        minWidth: 150
    },
    {
        prop: 'Origen',
        label: 'Origen',
        minWidth: 100
    },
    {
        prop: 'TipoEvento',
        label: 'Tipo',
        minWidth: 150
    },
    {
        prop: 'FechaReport',
        label: 'Fecha Reporte',
        minWidth: 150
    },
    {
        prop: 'EstadoReporte',
        label: 'Estado Reporte',
        minWidth: 150
    }
]

const table_plus = [
    {
        prop: "Barrio",
        label: "Barrio", 
    },
    {
        prop: "Prioridad",
        label: "Prioridad", 
    },
    {
        prop: "Encargado",
        label: "Encargado", 
    },
    {
        prop: "Solicitante",
        label: "Solicitante", 
    },
    {
        prop: "Telefono",
        label: "Telefono", 
    },
    {
        prop: "Dirección",
        label: "Dirección", 
    },
    {
        prop: "Email",
        label: "Email", 
    },
    {
        prop: "FecLimCierre",
        label: "Fecha Limite Cierre", 
    },
    {
        prop: "FecCierre",
        label: "Fecha Cierre", 
    },
    {
        prop: "Observaciones",
        label: "Descripción", 
    },
    {
        prop: "DescripcionST",
        label: "DescripcionST", 
    },
    {
        prop: "Coordenadas",
        label: "Coordenadas", 
    },
  ]

export default [table, table_plus]
